import { DirectUpload } from '@rails/activestorage';

/**
 * Envoi direct au stockage — le back ne reçoit qu'un `signed_id`.
 *
 * C'est ce qui rend les 100 Mo tenables : en base64 le corps de la requête
 * serait un tiers plus lourd et passerait entièrement en mémoire côté Rails.
 *
 * L'endpoint vit à la racine de l'API, pas sous son préfixe `/api` : on le
 * dérive de `REACT_APP_API_URL` plutôt que de le poser en dur, pour qu'un
 * changement d'hôte n'ait qu'un seul endroit à toucher.
 */
function directUploadUrl() {
  const api = process.env.REACT_APP_API_URL || '';
  const { origin } = new URL(api, window.location.origin);
  return `${origin}/rails/active_storage/direct_uploads`;
}

function authorizationHeader() {
  const jwt = new URLSearchParams(window.location.search).get('jwt')
    || window.localStorage.getItem('jwt');
  return jwt ? `Bearer ${jwt}` : null;
}

/**
 * @param {File} file
 * @param {(percent: number) => void} [onProgress] progression en pourcents —
 *   sans elle, un envoi de plusieurs dizaines de mégaoctets paraît planté.
 * @returns {Promise<string>} le `signed_id` du blob créé.
 */
export function uploadDirect(file, onProgress) {
  const token = authorizationHeader();

  return new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, directUploadUrl(), {
      directUploadWillCreateBlobWithXHR(xhr) {
        if (token) xhr.setRequestHeader('Authorization', token);
      },
      directUploadWillStoreFileWithXHR(xhr) {
        if (!onProgress) return;
        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) {
            onProgress(Math.round((event.loaded / event.total) * 100));
          }
        });
      },
    });

    upload.create((error, blob) => (error ? reject(error) : resolve(blob.signed_id)));
  });
}
